<template>
  <v-card v-if="results">
    <v-toolbar
      color="primary"
      dark
    >
      <v-card-title>
        {{ results.cusip }}
      </v-card-title>
      <v-spacer></v-spacer>
      <collection-item-save
        v-model="showSave"
        :cusip="results"
        :show-new-folder.sync="showNewFolder"
        :saved-collection.sync="savedCollection"
      />
      <collection-new v-model="showNewFolder" />
      <v-snackbar
        v-if="savedCollection"
        v-model="snackbar"
        absolute
        :timeout="-1"
      >
        Added <strong>{{ results.cusip }}</strong> to {{ savedCollection.name }}
        <template v-slot:action>
          <v-divider></v-divider>
          <v-btn
            small
            class="mx-2"
            text
            color="info"
            :to="`/collections/${savedCollection.id}`"
          >
            View
          </v-btn>
          <v-btn
            small
            text
            color="info"
            @click.stop="generateAndGo"
          >
            Generate download
          </v-btn>
          <v-btn
            icon
            @click="snackbar = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      <div
        v-if="!savedCollection"
        class="mx-2"
      >
        Add a security to a folder to download its full dataset
      </div>
      <v-btn
        color="primary"
        @click.stop="showSave=true"
      >
        <v-icon class="mr-1">
          mdi-plus
        </v-icon>
        Add
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <table>
            <tr v-if="false && results['is_covered'] != true">
              <td class="px-4">
                Level11 Coverage
              </td>
              <td class="px-4">
                {{ results['coverage_case'] }}  {{ results['is_covered'] }}
              </td>
            </tr>
            <tr
              v-for="(field,index) in fields"
              :key="index"
            >
              <td class="px-4">
                {{ fieldNames[field] }}
              </td>
              <td
                class="px-4"
                style="color:black;"
              >
                {{ results[field] }}
              </td>
            </tr>
          </table>
        </v-col>
        <v-col>
          <v-btn
            color="info"
            outlined
            text
            v-if="isRMBS"
            :target="results.cusip"
            :disabled="! results.agency_site_link"
            :href="results.agency_site_link"
          >
            <v-icon class="mr-1">
              mdi-link
            </v-icon>
            View on {{ results.agency_name }} website
          </v-btn>
        </v-col>
        <v-col  v-if="summary && summary['factor_date']">
          <table>
            <tr>
              <td class="px-4">
                Factor date
              </td>
              <td
                class="px-4"
                style="color:black;"
              >
                {{ summary['factor_date'] }}
              </td>
            </tr>
          </table>

        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="group in dataGroups"
          :key="group"
          :cols="12 / dataGroups.length"
        >
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 4 : 0">
              <v-card-title v-text="`${group} Summary`">
              </v-card-title>
              <v-card-text>
                <climate-summary :rscores="summaryRscores" :isCMBS="isCMBS" :parentIsCusipSearchResult="true" v-if="((summary && properties) || (summary && summaryRscores)) && group === 'Climate'"></climate-summary>
                <social-summary :socialData="summary" :parentIsCusipSearchResult="true" :isCMBS="isCMBS" v-else-if="((summary && properties) || (summary && results)) && group === 'Social'"></social-summary>
                <economic-summary :economicData="summary" v-else-if="((summary && properties) || (summary && results)) && group === 'Economic'"></economic-summary>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <div v-if="isCMBS">
        <location-map></location-map>
        <drive-time-button-group v-on:drive-time-changed="refreshCusipData"></drive-time-button-group>
        <v-row v-if="properties">
          <v-col>
            <property-detail-table :items="properties"/>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { startFileGeneration } from '@/utils/collections'
import CollectionItemSave from '@/components/CollectionItemSave.vue'
import CollectionNew from '@/components/CollectionNew.vue'
import ClimateSummary from '@/components/ClimateSummary.vue'
import SocialSummary from '@/components/SocialSummary.vue'
import EconomicSummary from '@/components/EconomicSummary.vue'
import LocationMap from '@/components/LocationMap.vue'
import PropertyDetailTable from '@/components/PropertyDetailTable.vue'
import DriveTimeButtonGroup from '@/components/DriveTimeButtonGroup.vue'

import { mapState } from 'vuex'
export default {
  components: {
    CollectionItemSave,
    CollectionNew,
    ClimateSummary,
    SocialSummary,
    LocationMap,
    PropertyDetailTable,
    DriveTimeButtonGroup,
    EconomicSummary
  },
  data: () => ({
    savedCollection: null,
    showSave: false,
    showNewFolder: false,
    fieldNames: { agency_name: 'Agency', security_type_name: 'Security type', issue_date: 'Issue date', maturity_date: 'Maturity date' },
  }),
  computed: {
    isRMBS: function() {
      return this.results && (this.results.security_type == 'pt' || this.results.security_type == 'crt' )
    },
    isCMBS: function() {
      return this.results && this.results.security_type == 'cmbs'
    },
    fields: function() {
      return this.isRMBS ? ['agency_name', 'security_type_name', 'issue_date', 'maturity_date'] : ['agency_name', 'security_type_name']
    },
    dataGroups: function() {
      if (this.isRMBS) {
        return ['Climate', 'Social', 'Economic']
      } else {
        return ['Climate', 'Social']
      }
    },
    snackbar: {
      get() {
        return this.savedCollection != null
      },
      set(value) {
        if (value === false) {
          this.savedCollection = null
        }
      }
    },
    ...mapState({
      results: state => state.currentCusipData,
      summary: state => {
        let summary = state.summaryData;
        //working around the fact that cmbs securities don't have pct_commute_gte40mins values, so we're manually computing that
        if(summary && !Object.keys(summary).includes('pct_commute_gte40mins')) {
                summary['pct_commute_gte40mins'] = 100 - summary['pct_commute_20to40mins'] - summary['pct_commute_lte20mins']
            }
        return summary;
        },
      summaryRscores: state => state.summaryRscores,
      properties: state => state.propertyData,
      propertyRscores: state => state.propertyRscores,
    })
  },
  created() {
    if (this.$route.params.cusip) {
      this.$store.dispatch('getCusipData',this.$route.params.cusip)
    }
  },
  methods: {
    refreshCusipData() {
          /* TODO: make map redraw smoother */
          this.$store.dispatch('refreshCusipData')
    },
    clearIsochrones() {
        this.$store.dispatch('clearIsochrones')
    },
    generateAndGo() {
      if (this.savedCollection) {
        startFileGeneration(this.savedCollection.id).then(() => {
          this.$router.push(`/collections/${this.savedCollection.id}`)
        })
      }
    },
    getRandomCusip() {
      this.$store.dispatch('getCusipData', 'random')
    },
    updateCusip(e) {
      this.$store.dispatch('getCusipData', e)
    }
  },

}
</script>
<style scoped>
.v-snack__wrapper {
  max-width:10000px !important;
}
table.property-list th {
  text-align: left;
}
</style>
